export default __webpack_public_path__ + "static/media/icon_check_no.7e259529.svg";